module.exports = __webpack_public_path__ + "f2776cd1bc9390a45a269e48362e7b09.png";